import React, { Component } from "react";
import { withLanguage } from "../i18n";

class Topbar extends Component {
  render() {
    return (
      <div className="topbar-one">
        <div className="container">
          <div className="topbar-one__left">
            <a href="#none">{this.props.t.email}</a>
            <a href="#none">{this.props.t.phone}</a>
          </div>
          <div className="topbar-one__right">
            <a href="/login">{this.props.t.login}</a>
            <a href="/register">{this.props.t.register}</a>
            <button className="ady-language-toggle" onClick={() => this.props.setLanguage(this.props.language === "vi" ? "en" : "vi")}>
              {this.props.language === "vi" ? "EN" : "VI"}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default withLanguage(Topbar);
